import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { from } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { PermissionsService } from './permissions.service';

/**
 * Guard factory que verifica permisos por ruta.
 *
 * Uso en rutas:
 *   { path: 'inventario', canActivate: [permissionGuard('inventory:view')], component: ... }
 *   { path: 'ventas', canActivate: [permissionGuard(['sales:view', 'sales:cierre_bol:view'])], component: ... }
 *
 * Si el usuario no tiene el permiso, redirige a la raíz '/'.
 */
export function permissionGuard(requiredPermission: string | string[]): CanActivateFn {
  return () => {
    const authService = inject(AuthService);
    const permissionsService = inject(PermissionsService);
    const router = inject(Router);

    return from(authService.isAuthenticated()).pipe(
      map((authenticated) => {
        if (!authenticated) {
          return router.createUrlTree(['/login']);
        }

        const permissions = Array.isArray(requiredPermission) ? requiredPermission : [requiredPermission];
        const hasPermission = permissionsService.canAny(permissions);

        if (hasPermission) {
          return true;
        }

        // Sin permiso → redirigir al home
        return router.createUrlTree(['/']);
      })
    );
  };
}
